import { Text } from "@chakra-ui/react";
import Layout from "../../containers/Layout";
import Seo from "../Seo/Seo";

const Subscribe = (  ) => {
    return (
        <Layout mt={136}>
           <Seo title="Subscribe" path="/subscribe" noIndex />
           <Text>
Enter your email, subscribe and get notify when the website is release.        
 </Text>
        </Layout>
    );
}

export default Subscribe;
